module.exports = __webpack_public_path__ + "img/id.f703751d.png";